import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { BlackoutDatesRules } from '@app/pages/checkout-app/checkout-layout/main/components/extensions/components/extension-components/date-picker/components/date-picker-blackout-dates/configs';
import { Shop } from '@pdqdev/pdq-shared/dist/entities/Shop';

@Component({
  selector: 'date-picker-blackout-dates',
  templateUrl: './date-picker-blackout-dates.component.html',
  standalone: false,
})
export class DatePickerBlackoutDatesComponent implements OnInit, OnDestroy {
  @Input() formGroup: UntypedFormGroup;
  @Input() shop: Shop;
  readonly formArrayFieldName = 'blackoutDatesRules';
  entities;
  blackoutDatesRules = [...BlackoutDatesRules];

  constructor() {}
  ngOnDestroy() {}

  ngOnInit() {
    this.entities = this.blackoutDatesRules.map((b) => b.entity);
  }
}
